export default {
    setLocalStorage(key, value, expired) {
        /*
        * setLocalStorage 存储方法
        * @ param {String} 	key 键
        * @ param {String} 	value 值，
        * @ param {String} 	expired 过期时间，以分钟为单位，非必须
        */
        let source = this.source;
        source[key] = JSON.stringify(value);
        if (expired) {
            source[`${key}__expires__`] = Date.now() + 1000 * 60 * expired
        }
        return value;
    },
    getLocalStorage(key) {
        /*
        * getLocalStorage 获取方法
        * @ param {String} 	key 键
        * @ param {String} 	expired 存储时为非必须字段，所以有可能取不到，默认为 Date.now+1
        */
        const source = this.source,
            expired = source[`${key}__expires__`] || Date.now + 1;
        const now = Date.now();
        if (now >= expired) {
            this.remove(key);
            return;
        }
        return source[key] ? JSON.parse(source[key]) : source[key];
    },
    removeLocalStorage(key) {
        const data = this.source,
            value = data[key];
        delete data[key];
        delete data[`${key}__expires__`];
        return value;
    }
}